import React from 'react'
import { PetalPropsData } from '../../interfaces'
import { BarProgressContainer } from './style'

interface BarProgressProps {
  data: PetalPropsData
  color: string
}
export const BarProgress = ({ color, data }: BarProgressProps) => {
  return (
  <BarProgressContainer color={color} range={data?.indice}>
    <div className='move' ></div>
  </BarProgressContainer>
  )
}
